import { render, staticRenderFns } from "./BlackGoldMaintenanceOverlay.vue?vue&type=template&id=77214536"
import script from "./BlackGoldMaintenanceOverlay.vue?vue&type=script&lang=js"
export * from "./BlackGoldMaintenanceOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports